import { render, staticRenderFns } from "./HolidayDetail.vue?vue&type=template&id=6a972dc6"
import script from "../../controllers/holiday/holiday-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/holiday/holiday-detail.js?vue&type=script&lang=js&external"
import style0 from "./HolidayDetail.vue?vue&type=style&index=0&id=6a972dc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports